import { Input } from "../../ui/Input";
export const CompanyPrefrenceForm = ({
    formData,
    handleCompanyChange,
    isEditing,
}) =>{
    return(
        <div className="transaction-form">
                
                <Input
                        label="Logo URL "
                        type="text"
                        name="URL"
                        value={formData.URL}
                        disabled={!isEditing}
                        onChange={handleCompanyChange}
                      />
                  <Input
                        label="Primary Colour "
                        type="text"
                        name="PrimaryColor"
                        value={formData.PrimaryColor}
                  disabled={!isEditing}
                  onChange={handleCompanyChange}
                      />
                      <Input
                        label="Secondary Colour "
                        type="text"
                        name="SecondaryColor"
                        value={formData.SecondaryColor}
                  disabled={!isEditing}
                  onChange={handleCompanyChange}
                      />
                      <Input
                        label="Tertiary Colour "
                        type="text"
                        name="TertiaryColor"
                        value={formData.TertiaryColor}
                  disabled={!isEditing}
                  onChange={handleCompanyChange}
                      />
                </div>
    )
}